<template>
  <div class="banner overflow-hidden">
    <img src="../../assets/team.default.png" alt="" v-if="list.length===0">
    <img :src="first.adImgUrl" alt="" @error="teamAvaError" v-else-if="list.length===1">
    <v-slider :data="list" v-else>
      <li v-for="ad in list" @click="handler(ad)">
        <img :src="ad.adImgUrl" alt="" @error="teamAvaError">
      </li>
    </v-slider>
  </div>
</template>

<script>
  import VSlider from "../v-slider";
  import {teamAvaErrorMixin} from "../../lib/mixin";

  export default {
    name: "team-banner",
    components: {VSlider},
    mixins: [teamAvaErrorMixin],
    props: {
      info: Object,
    },
    computed: {
      list() {
        const {serviceAdSettingVoList} = this.info;
        if (serviceAdSettingVoList) return serviceAdSettingVoList.map(r => {
          return r.sysAdSetting;
        }) || [];
        return [];
      },
      first() {
        const {list} = this;
        if (list.length) return list[0];
        return {};
      }
    },
    methods: {
      handler(data) {
        console.log('data', data);
        if (data.clickType == "DETAILS") {
          let id = data.clickVal;
          switch (data.clickLayout) {
            case "DOCARTICLE":
              this.$router.push(`/doc/article/${id}`);
              break;
            case "DOCCARD":
              this.$router.push(`/onlineDoctorCard?docId=${id}`);
              break;
            case "TEAMINFO":
              this.$router.push(`/team/${id}/detail`);
              break;
            case "NEWS":
              this.$router.push(`/news/detail/${id}`);
              break;
          }
        }
        data.clickType == "URL" && (location.href = data.clickVal);
      },
    },
  }
</script>

<style scoped lang="scss">
  @import "../../common/public";

  img {
    @include w_h(px2rem(375px), px2rem(235px));
  }
</style>



// WEBPACK FOOTER //
// src/plugins/team/team-banner.vue